import axios from "axios";
import {
  UpdateOnEventDetailModel,
  UpdateOnEventInstallationModel,
} from "@/models/classes/event/on_event";
import { EventDetailInstallModel } from "@/models/classes/event/event_detail_install";

// Set to true to return mockup data, or false to call the actual API endpoint
const isMockup = false;

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

// ============================================================================
// Mockup Data Variables
// ============================================================================

// Status 2: SALE - Assigned (สั่งสินค้า: มีเฉพาะยอดสั่ง requestAmount)
const mockEventStatus2 = {
  eventId: 2,
  customerId: 12247,
  customerPlanId: 12247,
  eventRole: "SALE",
  eventName: "1. [Status 2] ได้รับมอบหมาย - สั่งซื้อสินค้า Pre-Event",
  eventStatusCode: "2",
  eventStatusName: "ได้รับมอบหมาย",
  eventStatusGroup: 1,
  shiptoAddress: {
    address: "987/6 ถนนสุขุมวิท",
    province: { value: "10", text: "กรุงเทพมหานคร" },
    district: { value: "1039", text: "วัฒนา" },
    subDistrict: { value: "103901", text: "คลองเตยเหนือ" },
    zipCode: { value: "10110", text: "10110" },
  },
  shiptoName: "ร้านส้มตำเจ๊เจิม",
  shiptoDate: "2026-04-15 09:00:00",
  installDate: "2026-04-14 14:00:00",
  shiptoContact: "081-234-5678",
  customerName: "คุณสมชาย ยอดรัก",
  customerContact: "089-999-8888",
  customerEmail: "somchai@example.com",
  eventDate: "15 เม.ย. 69 | 09:30 น.",
  product: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "Z31122862827",
      name: "เบียร์ช้าง Espresso 490 ซีซี. Can 4.8 ดีกรี",
      requestAmount: 3,
      actualPrice: 100,
    },
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "Z31122862828",
      name: "เบียร์ช้าง คลาสสิก 490 ซีซี. Can 4.8 ดีกรี",
      requestAmount: 5,
      actualPrice: 80,
    },
  ],
  productSummary: 700,
  poppos: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "POP001",
      name: "ป้ายประชาสัมพันธ์สงกรานต์",
      requestAmount: 2,
    },
  ],
  equipment: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "EQ001",
      name: "Tower เบียร์สด 5 ลิตร",
      requestAmount: 2,
    },
  ],
  serving: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "SV001",
      name: "แก้วเบียร์ 16 ออนซ์",
      requestAmount: 50,
    },
  ],
  requestAmountTechnician: 2,
  requestPGAmount: 2,
  detail: "โปรดเตรียมเบียร์เย็นและอุปกรณ์ล่วงหน้า 1 วัน",
};

// Status 3: SALE - Pending Confirm Product (รอรวบรวมสินค้า / รออนุมัติสินค้า: แสดงเฉพาะยอดสั่ง requestAmount)
const mockEventStatus3 = {
  eventId: 3,
  customerId: 12248,
  customerPlanId: 12248,
  eventRole: "SALE",
  eventName: "2. [Status 3] รอรวบรวมสินค้า - กิจกรรมคลังสินค้า",
  eventStatusCode: "3",
  eventStatusName: "รอรวบรวมสินค้า",
  eventStatusGroup: 2,
  shiptoAddress: "456 ถนนพหลโยธิน แขวงลาดยาว เขตจตุจักร กรุงเทพฯ 10900",
  shiptoName: "ร้านอาหารพหลวิว",
  shiptoDate: "2026-04-18 10:00:00",
  installDate: "2026-04-17 15:00:00",
  shiptoContact: "082-345-6789",
  customerName: "คุณวิภาวดี มีสุข",
  customerContact: "088-777-6666",
  customerEmail: "wipawadee@example.com",
  eventDate: "18 เม.ย. 69 | 10:00 น.",
  product: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "Z31122862829",
      name: "เบียร์ช้าง Cold Brew 490 ซีซี. Can 4.8 ดีกรี",
      requestAmount: 10,
      actualPrice: 60,
    },
  ],
  productSummary: 600,
  poppos: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "POP002",
      name: "ร่มสนามกันแดด Chang",
      requestAmount: 3,
    },
  ],
  equipment: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "EQ002",
      name: "ถังแช่เครื่องดื่ม 100 ลิตร",
      requestAmount: 1,
    },
  ],
  serving: [],
  requestAmountTechnician: 1,
  requestPGAmount: 1,
  detail: "กำลังรวบรวมสินค้าในคลังสินค้าเพื่อจัดส่ง",
};

// Status 4 (Variation 1): LSALE - Pending Technician Assign (ครั้งแรก: actualAmountTechnician = 0)
const mockEventStatus4 = {
  eventId: 4,
  customerId: 12249,
  customerPlanId: 12249,
  eventRole: "LSALE",
  eventName: "3. [Status 4.1] รอระบุช่าง (ครั้งแรก - อนุมัติ/ไม่อนุมัติ)",
  eventStatusCode: "4",
  eventStatusName: "รอระบุช่าง",
  eventStatusGroup: 1,
  shiptoAddress: "123/45 ถนนรัชดาภิเษก เขตห้วยขวาง กรุงเทพฯ 10310",
  shiptoName: "ร้านดนตรีบาร์บาร์",
  shiptoDate: "2026-04-20 13:00:00",
  installDate: "2026-04-20 11:00:00",
  shiptoContact: "083-456-7890",
  customerName: "คุณณัฐพงษ์ ใจดี",
  customerContact: "087-654-3210",
  customerEmail: "nattapong@example.com",
  eventDate: "20 เม.ย. 69 | 13:00 น.",
  product: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "Z31122862828",
      name: "เบียร์ช้าง คลาสสิก 490 ซีซี",
      requestAmount: 20,
      actualPrice: 80,
    },
  ],
  productSummary: 1600,
  poppos: [],
  equipment: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "EQ003",
      name: "ชุดหัวจ่ายเบียร์สด 2 หัว",
      requestAmount: 2,
    },
  ],
  serving: [],
  requestAmountTechnician: 2,
  actualAmountTechnician: 0,
  technicians: [],
  requestPGAmount: 2,
  detail: "ต้องการช่างที่มีความชำนาญติดตั้งชุดหัวจ่าย 2 หัว",
};

// Status 4 (Variation 2): LSALE - Pending Technician Assign (ครั้งที่ 2: actualAmountTechnician > 0)
const mockEventStatus4_2 = {
  eventId: 401,
  customerId: 122492,
  customerPlanId: 122492,
  eventRole: "LSALE",
  eventName: "4. [Status 4.2] รอระบุช่าง (ครั้งที่ 2 - ระบุพนักงานให้ครบ)",
  eventStatusCode: "4",
  eventStatusName: "รอระบุช่าง",
  eventStatusGroup: 1,
  shiptoAddress: "123/45 ถนนรัชดาภิเษก เขตห้วยขวาง กรุงเทพฯ 10310",
  shiptoName: "ร้านดนตรีบาร์บาร์ (ครั้งที่ 2)",
  shiptoDate: "2026-04-20 13:00:00",
  installDate: "2026-04-20 11:00:00",
  shiptoContact: "083-456-7890",
  customerName: "คุณณัฐพงษ์ ใจดี",
  customerContact: "087-654-3210",
  customerEmail: "nattapong@example.com",
  eventDate: "20 เม.ย. 69 | 13:00 น.",
  product: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "Z31122862828",
      name: "เบียร์ช้าง คลาสสิก 490 ซีซี",
      requestAmount: 20,
      actualPrice: 80,
    },
  ],
  productSummary: 1600,
  poppos: [],
  equipment: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "EQ003",
      name: "ชุดหัวจ่ายเบียร์สด 2 หัว",
      requestAmount: 2,
    },
  ],
  serving: [],
  requestAmountTechnician: 2,
  actualAmountTechnician: 2,
  technicians: [
    {
      contactId: 1,
      employeeId: "EMP001",
      firstName: "ประสงค์",
      lastName: "ทัศศิริ",
      firstname: "ประสงค์",
      lastname: "ทัศศิริ",
    },
  ],
  requestPGAmount: 2,
  detail: "ระบุพนักงานให้ครบทั้ง 2 คน",
};

// Status 5 (Variation 1): SALE - Pending Customer Accept (มียอดสั่งและยอดได้รับไม่ตรงกันบางรายการ)
const mockEventStatus5 = {
  eventId: 5,
  customerId: 12250,
  customerPlanId: 12250,
  eventRole: "SALE",
  eventName: "6. [Status 5.1] รอลูกค้ายืนยันรับงาน (มียอดไม่ตรงกัน)",
  eventStatusCode: "5",
  eventStatusName: "รอลูกค้ายืนยันรับงาน",
  eventStatusGroup: 1,
  shiptoAddress: "888 ถนนพระราม 9 เขตห้วยขวาง กรุงเทพฯ 10310",
  shiptoName: "ร้านอาหารแสงจันทร์",
  shiptoDate: "2026-04-22 17:00:00",
  installDate: "2026-04-22 14:00:00",
  shiptoContact: "084-567-8901",
  customerName: "คุณประเสริฐ รัตนะ",
  customerContact: "086-555-4444",
  customerEmail: "prasert@example.com",
  eventDate: "22 เม.ย. 69 | 17:00 น.",
  product: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "Z31122862827",
      name: "เบียร์ช้าง Espresso 490 ซีซี",
      requestAmount: 5,
      actualAmount: 3,
      actualPrice: 100,
    },
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "Z31122862828",
      name: "เบียร์ช้าง คลาสสิก 490 ซีซี",
      requestAmount: 10,
      actualAmount: 10,
      actualPrice: 80,
    },
  ],
  productSummary: 1100,
  poppos: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "POP001",
      name: "ป้ายประชาสัมพันธ์",
      requestAmount: 4,
      actualAmount: 2,
    },
  ],
  equipment: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "EQ001",
      name: "Tower 5 ลิตร",
      requestAmount: 3,
      actualAmount: 1,
    },
  ],
  serving: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "SV001",
      name: "แก้วเบียร์ 16 ออนซ์",
      requestAmount: 100,
      actualAmount: 50,
    },
  ],
  requestAmountTechnician: 3,
  actualAmountTechnician: 1,
  requestPGAmount: 2,
  actualPGAmount: 1,
  detail: "ปรับลดจำนวนเนื่องจากสถานที่จัดงานมีพื้นที่จำกัด",
};

// Status 5 (Variation 2): SALE - Pending Customer Accept (ยอดสั่งและยอดได้รับตรงกันทุกรายการ)
const mockEventStatus5_2 = {
  eventId: 501,
  customerId: 122501,
  customerPlanId: 122501,
  eventRole: "SALE",
  eventName: "7. [Status 5.2] รอลูกค้ายืนยันรับงาน (ได้รับตรงตามสั่งทุกรายการ)",
  eventStatusCode: "5",
  eventStatusName: "รอลูกค้ายืนยันรับงาน",
  eventStatusGroup: 1,
  shiptoAddress: "101 ถนนสีลม แขวงสีลม เขตบางรัก กรุงเทพฯ 10500",
  shiptoName: "ร้านสีลมแกรนด์แลนด์",
  shiptoDate: "2026-04-23 14:00:00",
  installDate: "2026-04-23 11:00:00",
  shiptoContact: "085-999-0000",
  customerName: "คุณศิริพงษ์ สมบูรณ์",
  customerContact: "081-888-7777",
  customerEmail: "siripong@example.com",
  eventDate: "23 เม.ย. 69 | 14:00 น.",
  product: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "Z31122862827",
      name: "เบียร์ช้าง Espresso 490 ซีซี",
      requestAmount: 5,
      actualAmount: 5,
      actualPrice: 100,
    },
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "Z31122862828",
      name: "เบียร์ช้าง คลาสสิก 490 ซีซี",
      requestAmount: 10,
      actualAmount: 10,
      actualPrice: 80,
    },
  ],
  productSummary: 1300,
  poppos: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "POP001",
      name: "ป้ายประชาสัมพันธ์",
      requestAmount: 2,
      actualAmount: 2,
    },
  ],
  equipment: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "EQ001",
      name: "Tower 5 ลิตร",
      requestAmount: 1,
      actualAmount: 1,
    },
  ],
  serving: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "SV001",
      name: "แก้วเบียร์ 16 ออนซ์",
      requestAmount: 50,
      actualAmount: 50,
    },
  ],
  requestAmountTechnician: 2,
  actualAmountTechnician: 2,
  requestPGAmount: 2,
  actualPGAmount: 2,
  detail: "ได้รับสินค้าและอุปกรณ์ครบถ้วนตรงตามสั่งทุกรายการ",
};

// Status 7: SALE/LSALE - Rejected (ไม่รับงาน - Read Only)
const mockEventStatus7 = {
  eventId: 7,
  customerId: 12254,
  customerPlanId: 12254,
  eventRole: "LSALE",
  eventName: "7. [Status 7] ไม่รับงาน - กิจกรรมปฏิเสธการรับงาน",
  eventStatusCode: "7",
  eventStatusName: "ไม่รับงาน",
  eventStatusGroup: 5,
  shiptoAddress: "99/88 หมู่บ้านศุภาลัย ถนนกิ่งแก้ว สมุทรปราการ 10540",
  shiptoName: "ร้านศุภาลัยการ์เดน",
  shiptoDate: "2026-07-04 05:00:00",
  installDate: "2026-07-03 15:00:00",
  shiptoContact: "089-111-2222",
  customerName: "คุณสมศักดิ์ ปฏิเสธ",
  customerContact: "089-111-2222",
  customerEmail: "somsak@example.com",
  eventDate: "04 ก.ค. 69 | 05:00 น.",
  product: [],
  productSummary: 0,
  poppos: [],
  equipment: [],
  serving: [],
  requestAmountTechnician: 0,
  actualAmountTechnician: 0,
  requestPGAmount: 0,
  actualPGAmount: 0,
  detail: "ปฏิเสธการรับงานเนื่องจากไม่สะดวกจัดงานในวันดังกล่าว",
};

// Status 8: SALE - Upload Receipt (อัพโหลดใบเสร็จ / รอแนบใบเสร็จ: แสดงยอดสั่งและยอดได้รับจริง)
const mockEventStatus8 = {
  eventId: 8,
  customerId: 12251,
  customerPlanId: 12251,
  eventRole: "SALE",
  eventName: "8. [Status 8] อัพโหลดใบเสร็จ - สรุปรายการและแนบใบเสร็จ",
  eventStatusCode: "8",
  eventStatusName: "อัพโหลดใบเสร็จ",
  eventStatusGroup: 3,
  shiptoAddress: "99/1 ถนนสาทรเหนือ แขวงสีลม เขตบางรัก กรุงเทพฯ 10500",
  shiptoName: "ร้านรูฟท็อปสาทร",
  shiptoDate: "2026-04-25 18:00:00",
  installDate: "2026-04-25 12:00:00",
  shiptoContact: "085-678-9012",
  customerName: "คุณอนันต์ สุขสันต์",
  customerContact: "085-444-3333",
  customerEmail: "anan@example.com",
  eventDate: "25 เม.ย. 69 | 18:00 น.",
  product: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "Z31122862828",
      name: "เบียร์ช้าง คลาสสิก 490 ซีซี. Can 4.8 ดีกรี",
      requestAmount: 15,
      actualAmount: 15,
      actualPrice: 100,
    },
  ],
  productSummary: 1500,
  poppos: [],
  equipment: [],
  serving: [],
  requestAmountTechnician: 1,
  actualAmountTechnician: 1,
  requestPGAmount: 2,
  actualPGAmount: 2,
  detail: "งานเรียบร้อยแล้ว แนบใบเสร็จเพื่อปิดงาน",
};

// Status 9: LSALE - Pending Manager Approve (รอหัวหน้าอนุมัติ)
const mockEventStatus9 = {
  eventId: 9,
  customerId: 12252,
  customerPlanId: 12252,
  eventRole: "LSALE",
  eventName: "9. [Status 9] รอหัวหน้าอนุมัติ - พิจารณาอนุมัติการแก้ไข",
  eventStatusCode: "9",
  eventStatusName: "รอหัวหน้าอนุมัติ",
  eventStatusGroup: 1,
  shiptoAddress:
    "555 ถนนเพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง กรุงเทพฯ 10310",
  shiptoName: "ร้านการ์เดนเพชรบุรี",
  shiptoDate: "2026-04-28 16:00:00",
  installDate: "2026-04-28 10:00:00",
  shiptoContact: "086-789-0123",
  customerName: "คุณชัยวัฒน์ วงศ์สวัสดิ์",
  customerContact: "084-333-2222",
  customerEmail: "chaiwat@example.com",
  eventDate: "28 เม.ย. 69 | 16:00 น.",
  product: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "Z31122862827",
      name: "เบียร์ช้าง Espresso 490 ซีซี",
      requestAmount: 10,
      actualAmount: 8,
      actualPrice: 100,
    },
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "Z31122862829",
      name: "เบียร์ช้าง Cold Brew 490 ซีซี",
      requestAmount: 5,
      actualAmount: 3,
      actualPrice: 80,
    },
  ],
  productSummary: 1040,
  poppos: [],
  equipment: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "EQ001",
      name: "Tower 5 ลิตร",
      requestAmount: 4,
      actualAmount: 2,
    },
  ],
  serving: [],
  requestAmountTechnician: 2,
  actualAmountTechnician: 1,
  requestPGAmount: 2,
  actualPGAmount: 1,
  detail: "ลูกค้ายื่นขอปรับลดจำนวนสินค้าและอุปกรณ์ โปรดพิจารณาอนุมัติ",
};

// Status 10: TECH/SALE - Completed (จบงาน / เช็คอินปฏิบัติงาน)
const mockEventStatus10 = {
  eventId: 10,
  customerId: 12253,
  customerPlanId: 12253,
  eventRole: "TECH",
  eventName: "10. [Status 10] เช็คอินปฏิบัติงาน - ตรวจสอบอุปกรณ์",
  eventStatusCode: "10",
  eventStatusName: "เช็คอินปฏิบัติงาน",
  eventStatusGroup: 4,
  shiptoAddress: "777 ถนนแจ้งวัฒนะ แขวงทุ่งสองห้อง เขตหลักสี่ กรุงเทพฯ 10210",
  shiptoName: "ร้านแจ้งวัฒนะสเตชั่น",
  shiptoDate: "2026-04-30 09:00:00",
  installDate: "2026-04-30 08:00:00",
  shiptoContact: "087-890-1234",
  customerName: "คุณปิยะพงษ์ สุวรรณ",
  customerContact: "083-222-1111",
  customerEmail: "piyapong@example.com",
  eventDate: "30 เม.ย. 69 | 09:00 น.",
  product: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "Z31122862828",
      name: "เบียร์ช้าง คลาสสิก 490 ซีซี. Can 4.8 ดีกรี",
      requestAmount: 100,
      actualAmount: 100,
      actualPrice: 15000,
    },
  ],
  productSummary: 15000,
  paymentType: "deposit",
  depositAmount: 10000,
  imgUrls: [
    "463259",
    "463260",
    "463261",
    "463262",
  ],
  poppos: [],
  equipment: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "EQ001",
      name: "Tower เบียร์สด 5 ลิตร (จำนวน 2 ถัง)",
      requestAmount: 2,
      actualAmount: 2,
    },
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "EQ002",
      name: "ถังแช่เครื่องดื่ม 100 ลิตร",
      requestAmount: 1,
      actualAmount: 1,
    },
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "EQ003",
      name: "ชุดหัวจ่ายเบียร์สด 2 หัว",
      requestAmount: 1,
      actualAmount: 1,
    },
  ],
  serving: [],
  requestAmountTechnician: 1,
  actualAmountTechnician: 1,
  requestPGAmount: 0,
  actualPGAmount: 0,
  detail: "กดปุ่ม Check In เพื่อถ่ายภาพและบันทึกพิกัดการเช็คอิน",
};

// Status 4: LTECH - Pending Technician Assign
const mockEventStatusLTECH4 = {
  eventId: 1002,
  customerId: 12249,
  customerPlanId: 12249,
  eventRole: "LTECH",
  eventName: "12. [Status 4] มอบหมายช่าง - งานปฏิบัติตรวจสอบ (Lead Tech)",
  eventStatusCode: "4",
  eventStatusName: "มอบหมายช่าง",
  eventStatusGroup: 2,
  shiptoAddress: "123/45 ถนนพหลโยธิน แขวงลาดยาว เขตจตุจักร กรุงเทพฯ 10900",
  shiptoName: "ร้านอาหารพหลวิว",
  shiptoDate: "2026-05-02 11:00:00",
  installDate: "2026-05-02 09:00:00",
  shiptoContact: "083-456-7890",
  customerName: "คุณณัฐพงษ์ ใจดี",
  customerContact: "087-654-3210",
  customerEmail: "nattapong@example.com",
  eventDate: "02 พ.ค. 69 | 11:00 น.",
  product: [],
  poppos: [],
  equipment: [],
  serving: [],
  requestAmountTechnician: 2,
  actualAmountTechnician: 0,
  requestPGAmount: 0,
  actualPGAmount: 0,
  detail: "กรุณาระบุช่างสำหรับการตรวจสอบ",
};

// Status 9: LTECH - Pending Manager Approve
const mockEventStatusLTECH9 = {
  eventId: 1003,
  customerId: 12250,
  customerPlanId: 12250,
  eventRole: "LTECH",
  eventName: "13. [Status 9] รออนุมัติ - งานปฏิบัติตรวจสอบ (Lead Tech)",
  eventStatusCode: "9",
  eventStatusName: "รออนุมัติ",
  eventStatusGroup: 3,
  shiptoAddress: "456 ถนนสุขุมวิท แขวงคลองเตย เขตวัฒนา กรุงเทพฯ 10110",
  shiptoName: "ร้านดนตรีบาร์บาร์",
  shiptoDate: "2026-05-03 14:00:00",
  installDate: "2026-05-03 12:00:00",
  shiptoContact: "081-999-8888",
  customerName: "คุณสมชาย ใจดี",
  customerContact: "081-111-2222",
  customerEmail: "somchai@example.com",
  eventDate: "03 พ.ค. 69 | 14:00 น.",
  product: [
    {
      image:
        "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
      code: "Z31122862827",
      name: "เบียร์ช้าง Espresso 490 ซีซี. Can 4.8 ดีกรี",
      requestAmount: 5,
      actualAmount: 5,
      actualPrice: 100,
    },
  ],
  productSummary: 500,
  poppos: [],
  equipment: [],
  serving: [],
  requestAmountTechnician: 2,
  actualAmountTechnician: 2,
  requestPGAmount: 0,
  actualPGAmount: 0,
  detail: "รออนุมัติจากผู้จัดการ Lead Tech",
};

// Map of Event Details by Event ID
const mockEventDetailsMap: Record<number, any> = {
  2: mockEventStatus2,
  3: mockEventStatus3,
  301: mockEventStatus3,
  4: mockEventStatus4,
  401: mockEventStatus4_2,
  5: mockEventStatus5,
  501: mockEventStatus5_2,
  7: mockEventStatus7,
  8: mockEventStatus8,
  9: mockEventStatus9,
  10: mockEventStatus10,
  1001: mockEventStatus10,
  1002: mockEventStatusLTECH4,
  1003: mockEventStatusLTECH9,
};

// Comprehensive Mock List for Testing ordered strictly by eventStatusCode (2 -> 3 -> 4 -> 5 -> 7 -> 8 -> 9 -> 10)
const mockEventList = [
  // --- Status Code 2 ---
  {
    eventId: 2,
    eventName: "1. [Status 2] ได้รับมอบหมาย - สั่งซื้อสินค้า Pre-Event",
    address: "987/6 ถนนสุขุมวิท แขวงคลองเตย เขตวัฒนา กรุงเทพฯ 10110",
    eventDate: "2026-04-15T09:30:00",
    eventTime: "09:30",
    eventStatus: "ได้รับมอบหมาย",
    eventStatusCode: "2",
    eventStatusGroup: 1,
    eventRole: "SALE",
    customerEventId: 2,
    provinceName: "กรุงเทพมหานคร",
    isEdit: true,
    createdDate: "2026-04-01T09:00:00.000",
    updatedDate: "2026-04-01T09:00:00.000",
  },

  // --- Status Code 3 ---
  {
    eventId: 3,
    eventName: "2. [Status 3] รอรวบรวมสินค้า - กิจกรรมคลังสินค้า",
    address: "456 ถนนพหลโยธิน แขวงลาดยาว เขตจตุจักร กรุงเทพฯ 10900",
    eventDate: "2026-04-18T10:00:00",
    eventTime: "10:00",
    eventStatus: "รอรวบรวมสินค้า",
    eventStatusCode: "3",
    eventStatusGroup: 2,
    eventRole: "SALE",
    customerEventId: 3,
    provinceName: "กรุงเทพมหานคร",
    isEdit: false,
    createdDate: "2026-04-02T10:00:00.000",
    updatedDate: "2026-04-02T10:00:00.000",
  },
  {
    eventId: 301,
    eventName: "3. [Status 3] รออนุมัติสินค้า - รอดำเนินการอนุมัติ",
    address: "789 ถนนวิภาวดีรังสิต เขตดอนเมือง กรุงเทพฯ 10210",
    eventDate: "2026-04-19T11:00:00",
    eventTime: "11:00",
    eventStatus: "รออนุมัติสินค้า",
    eventStatusCode: "3",
    eventStatusGroup: 2,
    eventRole: "SALE",
    customerEventId: null,
    provinceName: "กรุงเทพมหานคร",
    isEdit: false,
    createdDate: "2026-04-02T11:00:00.000",
    updatedDate: "2026-04-02T11:00:00.000",
  },

  // --- Status Code 4 ---
  {
    eventId: 4,
    eventName: "4. [Status 4.1] รอระบุช่าง (ครั้งแรก - อนุมัติ/ไม่อนุมัติ)",
    address: "123/45 ถนนรัชดาภิเษก เขตห้วยขวาง กรุงเทพฯ 10310",
    eventDate: "2026-04-20T13:00:00",
    eventTime: "13:00",
    eventStatus: "รอระบุช่าง",
    eventStatusCode: "4",
    eventStatusGroup: 1,
    eventRole: "LSALE",
    customerEventId: null,
    provinceName: "กรุงเทพมหานคร",
    isEdit: true,
    createdDate: "2026-04-03T11:00:00.000",
    updatedDate: "2026-04-03T11:00:00.000",
  },
  {
    eventId: 401,
    eventName: "5. [Status 4.2] รอระบุช่าง (ครั้งที่ 2 - ระบุพนักงานให้ครบ)",
    address: "123/45 ถนนรัชดาภิเษก เขตห้วยขวาง กรุงเทพฯ 10310",
    eventDate: "2026-04-20T14:00:00",
    eventTime: "14:00",
    eventStatus: "รอระบุช่าง",
    eventStatusCode: "4",
    eventStatusGroup: 1,
    eventRole: "LSALE",
    customerEventId: null,
    provinceName: "กรุงเทพมหานคร",
    isEdit: true,
    createdDate: "2026-04-03T12:00:00.000",
    updatedDate: "2026-04-03T12:00:00.000",
  },

  // --- Status Code 5 ---
  {
    eventId: 5,
    eventName: "6. [Status 5.1] รอลูกค้ายืนยันรับงาน (มียอดไม่ตรงกัน)",
    address: "888 ถนนพระราม 9 เขตห้วยขวาง กรุงเทพฯ 10310",
    eventDate: "2026-04-22T17:00:00",
    eventTime: "17:00",
    eventStatus: "รอลูกค้ายืนยันรับงาน",
    eventStatusCode: "5",
    eventStatusGroup: 1,
    eventRole: "SALE",
    customerEventId: 5,
    provinceName: "กรุงเทพมหานคร",
    isEdit: true,
    createdDate: "2026-04-04T12:00:00.000",
    updatedDate: "2026-04-04T12:00:00.000",
  },

  {
    eventId: 501,
    eventName:
      "7. [Status 5.2] รอลูกค้ายืนยันรับงาน (ได้รับตรงตามสั่งทุกรายการ)",
    address: "101 ถนนสีลม แขวงสีลม เขตบางรัก กรุงเทพฯ 10500",
    eventDate: "2026-04-23T14:00:00",
    eventTime: "14:00",
    eventStatus: "รอลูกค้ายืนยันรับงาน",
    eventStatusCode: "5",
    eventStatusGroup: 1,
    eventRole: "SALE",
    customerEventId: 501,
    provinceName: "กรุงเทพมหานคร",
    isEdit: true,
    createdDate: "2026-04-04T14:00:00.000",
    updatedDate: "2026-04-04T14:00:00.000",
  },

  // --- Status Code 7 ---
  {
    eventId: 7,
    eventName: "7. [Status 7] ไม่รับงาน - กิจกรรมปฏิเสธการรับงาน",
    address: "99/88 หมู่บ้านศุภาลัย ถนนกิ่งแก้ว สมุทรปราการ 10540",
    eventDate: "2026-07-04T05:00:00",
    eventTime: "05:00",
    eventStatus: "ไม่รับงาน",
    eventStatusCode: "7",
    eventStatusGroup: 5,
    eventRole: "LSALE",
    customerEventId: null,
    provinceName: "สมุทรปราการ",
    isEdit: false,
    createdDate: "2026-06-29T11:16:24.680",
    updatedDate: "2026-08-07T13:58:23.360",
  },

  // --- Status Code 8 ---
  {
    eventId: 8,
    eventName: "8. [Status 8] อัพโหลดใบเสร็จ - สรุปรายการและแนบใบเสร็จ",
    address: "99/1 ถนนสาทรเหนือ แขวงสีลม เขตบางรัก กรุงเทพฯ 10500",
    eventDate: "2026-04-25T18:00:00",
    eventTime: "18:00",
    eventStatus: "อัพโหลดใบเสร็จ",
    eventStatusCode: "8",
    eventStatusGroup: 3,
    eventRole: "SALE",
    customerEventId: 8,
    provinceName: "กรุงเทพมหานคร",
    isEdit: true,
    createdDate: "2026-04-05T14:00:00.000",
    updatedDate: "2026-04-05T14:00:00.000",
  },

  // --- Status Code 9 ---
  {
    eventId: 9,
    eventName: "9. [Status 9] รอหัวหน้าอนุมัติ - พิจารณาอนุมัติการแก้ไข",
    address: "555 ถนนเพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง กรุงเทพฯ 10310",
    eventDate: "2026-04-28T16:00:00",
    eventTime: "16:00",
    eventStatus: "รอหัวหน้าอนุมัติ",
    eventStatusCode: "9",
    eventStatusGroup: 1,
    eventRole: "LSALE",
    customerEventId: null,
    provinceName: "กรุงเทพมหานคร",
    isEdit: false,
    createdDate: "2026-04-06T15:00:00.000",
    updatedDate: "2026-04-06T15:00:00.000",
  },

  // --- Status Code 10 ---
  {
    eventId: 10,
    eventName: "10. [Status 10] เช็คอินปฏิบัติงาน - ตรวจสอบอุปกรณ์",
    address: "777 ถนนแจ้งวัฒนะ แขวงทุ่งสองห้อง เขตหลักสี่ กรุงเทพฯ 10210",
    eventDate: "2026-04-30T09:00:00",
    eventTime: "09:00",
    eventStatus: "เช็คอินปฏิบัติงาน",
    eventStatusCode: "10",
    eventStatusGroup: 4,
    eventRole: "TECH",
    customerEventId: 10,
    provinceName: "กรุงเทพมหานคร",
    isEdit: false,
    createdDate: "2026-04-07T08:00:00.000",
    updatedDate: "2026-04-07T08:00:00.000",
  },
  {
    eventId: 1001,
    eventName: "11. [Status 10] จบงาน - ดำเนินการเสร็จสมบูรณ์",
    address: "99/88 ถนนกิ่งแก้ว อำเภอบางพลี สมุทรปราการ 10540",
    eventDate: "2026-05-01T10:00:00",
    eventTime: "10:00",
    eventStatus: "จบงาน",
    eventStatusCode: "10",
    eventStatusGroup: 4,
    eventRole: "SALE",
    customerEventId: 7,
    provinceName: "สมุทรปราการ",
    isEdit: false,
    createdDate: "2026-04-08T09:00:00.000",
    updatedDate: "2026-04-08T09:00:00.000",
  },
  {
    eventId: 1002,
    eventName: "12. [Status 4] มอบหมายช่าง - งานปฏิบัติตรวจสอบ (Lead Tech)",
    address: "123/45 ถนนพหลโยธิน แขวงลาดยาว เขตจตุจักร กรุงเทพฯ 10900",
    eventDate: "2026-05-02T11:00:00",
    eventTime: "11:00",
    eventStatus: "มอบหมายช่าง",
    eventStatusCode: "4",
    eventStatusGroup: 2,
    eventRole: "LTECH",
    customerEventId: 8,
    provinceName: "กรุงเทพมหานคร",
    isEdit: false,
    createdDate: "2026-04-09T09:00:00.000",
    updatedDate: "2026-04-09T09:00:00.000",
  },
  {
    eventId: 1003,
    eventName: "13. [Status 9] รออนุมัติ - งานปฏิบัติตรวจสอบ (Lead Tech)",
    address: "456 ถนนสุขุมวิท แขวงคลองเตย เขตวัฒนา กรุงเทพฯ 10110",
    eventDate: "2026-05-03T14:00:00",
    eventTime: "14:00",
    eventStatus: "รออนุมัติ",
    eventStatusCode: "9",
    eventStatusGroup: 3,
    eventRole: "LTECH",
    customerEventId: 9,
    provinceName: "กรุงเทพมหานคร",
    isEdit: false,
    createdDate: "2026-04-10T09:00:00.000",
    updatedDate: "2026-04-10T09:00:00.000",
  },
];


// Mock Technicians
const mockTechnicianList = [
  {
    contactId: 1,
    employeeId: "EMP001",
    firstName: "สมเกียรติ",
    lastName: "ช่างแอร์",
    firstname: "สมเกียรติ",
    lastname: "ช่างแอร์",
  },
  {
    contactId: 2,
    employeeId: "EMP002",
    firstName: "สมชาย",
    lastName: "เข็มกลัด",
    firstname: "สมชาย",
    lastname: "เข็มกลัด",
  },
  {
    contactId: 3,
    employeeId: "EMP003",
    firstName: "วิชัย",
    lastName: "ช่างไฟ",
    firstname: "วิชัย",
    lastname: "ช่างไฟ",
  },
  {
    contactId: 4,
    employeeId: "EMP004",
    firstName: "อนันต์",
    lastName: "บุนนาค",
    firstname: "อนันต์",
    lastname: "บุนนาค",
  },
  {
    contactId: 5,
    employeeId: "EMP005",
    firstName: "กิตติ",
    lastName: "สิงหา",
    firstname: "กิตติ",
    lastname: "สิงหา",
  },
];

// Mock Master Material Brands
const mockMasterMaterialBrandList = [
  { matBrandId: 101, matBrandName: "Chang Classic" },
  { matBrandId: 102, matBrandName: "Chang Cold Brew" },
  { matBrandId: 103, matBrandName: "Chang Espresso" },
];

// Mock Master Material Groups
const mockMasterMaterialGroupList = [
  {
    matGroupId: 1,
    matGroupName: "กลุ่มสินค้าหลัก",
    materialBrandList: mockMasterMaterialBrandList,
  },
  {
    matGroupId: 2,
    matGroupName: "กลุ่มสินค้าพรีเมียม",
    materialBrandList: mockMasterMaterialBrandList,
  },
];

// Mock Master Materials
const mockMasterMaterialList = [
  {
    matId: 1001,
    matType: "product",
    code: "Z31122862827",
    name: "เบียร์ช้าง Espresso 490 ซีซี. Can 4.8 ดีกรี",
    image:
      "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
    actualPrice: 100,
  },
  {
    matId: 1002,
    matType: "product",
    code: "Z31122862828",
    name: "เบียร์ช้าง คลาสสิก 490 ซีซี. Can 4.8 ดีกรี",
    image:
      "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
    actualPrice: 80,
  },
  {
    matId: 1003,
    matType: "product",
    code: "Z31122862829",
    name: "เบียร์ช้าง Cold Brew 490 ซีซี. Can 4.8 ดีกรี",
    image:
      "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
    actualPrice: 60,
  },
  {
    matId: 3001,
    matType: "product",
    code: "BRN-CLS-30L",
    name: "เบียร์สดช้างคลาสสิค 30 ลิตร",
    image: "",
    actualPrice: 3085.00,
  },
  {
    matId: 2001,
    matType: "poppos",
    code: "POP001",
    name: "ป้ายประชาสัมพันธ์สงกรานต์",
    image:
      "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
  },
  {
    matId: 2002,
    matType: "poppos",
    code: "POP002",
    name: "ร่มสนามกันแดด Chang",
    image:
      "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
  },
  {
    matId: 3001,
    matType: "equipment",
    code: "EQ001",
    name: "Tower เบียร์สด 5 ลิตร",
    image:
      "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
  },
  {
    matId: 3002,
    matType: "equipment",
    code: "EQ002",
    name: "ถังแช่เครื่องดื่ม 100 ลิตร",
    image:
      "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
  },
  {
    matId: 4001,
    matType: "serving",
    code: "SV001",
    name: "แก้วเบียร์ 16 ออนซ์",
    image:
      "https://d2d7w23f008r50.cloudfront.net/uploads/2024/04/17242-121064.png",
  },
];

// Mock Action Status Tabs
const mockActionStatusList = [
  { statusGroupIds: [1], statusName: "ต้อง action" },
  { statusGroupIds: [2, 3], statusName: "รออยู่" },
  { statusGroupIds: [4, 5, 6], statusName: "ปิดแล้ว" },
];

const mockQuestEvent = {
  result: true,
  responseCode: "200",
  responseMessage: "Success",
  responseDataSource: "db",
  isCalled: false,
  data: {
    shipto: {
      eventDate: "2026-09-30T00:00:00",
      shiptoDate: "2026-09-30T00:00:00",
      shiptoAddress: "",
      shiptoName: "",
      shiptoContact: "0973276010",
      startInstallDate: "2026-09-30T00:00:00",
      endInstallDate: "2026-09-30T00:00:00",
      customer: {
        customerName: "GLP",
        customerContact: "0973276010",
        customerEmail: "khanokwan.sup@gmail.com",
      },
      technicians: [
        {
          firstName: "ประสงค์",
          lastName: "ทัศศิริ",
        },
        {
          firstName: "ธนวัฒน์",
          lastName: "สังข์รอด",
        },
      ],
    },
    quests: [
      {
        eventId: 1102,
        questType: "payment",
        netTotal: 200.00,
        depositAmount: 200.00,
        isEnable: true,
      },
      {
        questType: "installation",
        netTotal: null,
        depositAmount: null,
        isEnable: false,
      },
    ],
  },
  error: null,
  xTotalCount: 0,
};

const mockQuestEventDetail = {
  result: true,
  responseCode: "200",
  responseMessage: "Success",
  responseDataSource: "mock",
  data: {
    eventId: 716,
    eventName: "27/08/2569",
    eventStatusCode: "2",
    eventStatusName: "ได้รับมอบหมาย",
    eventDate: "2026-09-20T10:00:00",
    shiptoAddress: {
      address: "ที่อยู่ของงานที่ติดตั้ง",
      province: {
        text: "เชียงราย",
        value: "57",
      },
      subdistrict: {
        text: "เวียง",
        value: "500901",
      },
      district: {
        text: "เชียงแสน",
        value: "5708",
      },
      zipCode: {
        text: "10290",
        value: "10290",
      },
    },
    shiptoName: "Phattarakorn Yamsai",
    shiptoContact: "0973276010",
    shiptoDate: "2026-09-10T07:00:00",
    startInstallDate: "2026-09-15T05:00:00",
    endInstallDate: "2026-09-15T05:00:00",

    customerEventId: null,
    customerCode: null,
    customerName: "Phattarakorn Yamsai",
    customerContact: "0973276010",
    customerEmail: "",

    product: [],
    productSummary: 0,
    poppos: [
      {
        matId: 2001,
        code: "BRN-001",
        name: "บูธ Chang Classic ขนาด 3 m (Size S)",
        note: "ขาตั้งดักระหว่างขนส่ง",
        actualAmount: 1,
        installAmount: 1,
      },
      {
        matId: 2002,
        code: "BRN-001",
        name: "ป้ายประชาสัมพันธ์",
        actualAmount: 1,
        installAmount: 1,
      },
      {
        matId: 2003,
        code: "BRN-001",
        name: "ถังสีเขียว 200 ลิตร",
        actualAmount: 1,
        installAmount: 1,
      },
    ],
    equipment: [
      {
        matId: 3001,
        code: "BRN-001",
        name: "ชุดท่อเบียร์",
        actualAmount: 2,
        installAmount: 2,
      },
      {
        matId: 3002,
        code: "BRN-001",
        name: "หัวจิ้มถังเบียร์ KEY COUPLER",
        actualAmount: 2,
        installAmount: 2,
      },
      {
        matId: 3003,
        code: "BRN-001",
        name: "ชุดวาล์วปรับความดัน CO2 REGULATOR",
        actualAmount: 2,
        installAmount: 2,
      },
    ],
    serving: [
      {
        matId: 4001,
        code: "BRN-001",
        name: "แก้วพลาสติก",
        actualAmount: 20,
        installAmount: 20,
      },
      {
        matId: 4002,
        code: "BRN-001",
        name: "เหยือกพลาสติก",
        actualAmount: 5,
        installAmount: 5,
      },
      {
        matId: 4003,
        code: "BRN-001",
        name: "ถาดสแตนเลส",
        actualAmount: 5,
        installAmount: 5,
      },
    ],

    actualAmountTechnician: 0,
    technicians: [
      {
        firstName: "",
        lastName: "",
      },
    ],
    payment: {
      beforeImgUrls: ["464772", "464772"],
      afterImgUrls: ["464772"],
      paymentType: "deposit",
      netAmount: 33525.00,
      depositAmount: 15000.00,
      receivedAmount: 18525.00,
    },
    reason: "",
    detail: "",
  },
  error: null,
};

const mockOnEventInstallationDetail = {
  result: true,
  responseCode: "200",
  responseMessage: "Success",
  responseDataSource: "mock",
  isCalled: true,
  data: {
    eventId: 1102,
    eventName: "กิจกรรมส่งเสริมการขายวันสงกรานต์",
    eventStatusCode: "2",
    eventStatusName: "ได้รับมอบหมาย",
    isConfirm: false,
    customerName: "นางสาวสุภารัตน์ มั่นคง",
    customerContact: "093-000-0000",
    customerEmail: "example@gmail.com",
    equipment: {
      items: [
        {
          code: "Z31122862827",
          name: "ชุดท่อเบียร์",
          image: "",
          requestAmount: 2,
          actualAmount: 2,
          installedAmount: 1,
          damagedAmount: 1,
          damagedReason: "ท่อเบียร์ตัน",
          lostAmount: 0,
          lostReason: "",
          remark: "",
          price: 0,
          actualPrice: 0,
          delFlag: false,
        },
        {
          code: "Z31122862827",
          name: "หัวจิ้มถังเบียร์ KEY COUPLER",
          image: "",
          requestAmount: 2,
          actualAmount: 2,
          installedAmount: 2,
          damagedAmount: 0,
          damagedReason: "",
          lostAmount: 0,
          lostReason: "",
          remark: "",
          price: 0,
          actualPrice: 0,
          delFlag: false,
        },
        {
          code: "Z31122862827",
          name: "ชุดวาล์วปรับความดัน CO2 REGULATOR",
          image: "",
          requestAmount: 2,
          actualAmount: 2,
          installedAmount: 2,
          damagedAmount: 0,
          damagedReason: "",
          lostAmount: 0,
          lostReason: "",
          remark: "",
          price: 0,
          actualPrice: 0,
          delFlag: false,
        },
      ],
      imgUrls: [],
    },
    poppos: {
      items: [
        {
          code: "Z31122862827",
          name: "บูธ Chang Classic ขนาด 3 m (Size S)",
          image: "",
          requestAmount: 2,
          actualAmount: 2,
          installedAmount: 1,
          damagedAmount: 0,
          damagedReason: "",
          lostAmount: 1,
          lostReason: "สูญหายระหว่างขนส่ง",
          remark: "ป้ายหลุดระหว่างทาง บูธไม่สมบูรณ์",
          price: 0,
          actualPrice: 0,
          delFlag: false,
        },
        {
          code: "230010647",
          name: "ธงทั่ง (ใบธง)",
          image: "",
          requestAmount: 2,
          actualAmount: 2,
          installedAmount: 2,
          damagedAmount: 0,
          damagedReason: "",
          lostAmount: 0,
          lostReason: "",
          remark: "",
          price: 0,
          actualPrice: 0,
          delFlag: false,
        },
        {
          code: "Z31122862827",
          name: "ถังสีเขียว 200 ลิตร",
          image: "",
          requestAmount: 2,
          actualAmount: 2,
          installedAmount: 2,
          damagedAmount: 0,
          damagedReason: "",
          lostAmount: 0,
          lostReason: "",
          remark: "",
          price: 0,
          actualPrice: 0,
          delFlag: false,
        },
      ],
      imgUrls: [],
    },
    serving: {
      items: [
        {
          code: "Z31122862827",
          name: "แก้วพลาสติก",
          image: "",
          requestAmount: 2,
          actualAmount: 2,
          installedAmount: 2,
          damagedAmount: 0,
          damagedReason: "",
          lostAmount: 0,
          lostReason: "",
          remark: "",
          price: 0,
          actualPrice: 0,
          delFlag: false,
        },
        {
          code: "Z31122862827",
          name: "เหยือกพลาสติก",
          image: "",
          requestAmount: 2,
          actualAmount: 2,
          installedAmount: 2,
          damagedAmount: 0,
          damagedReason: "",
          lostAmount: 0,
          lostReason: "",
          remark: "",
          price: 0,
          actualPrice: 0,
          delFlag: false,
        },
        {
          code: "Z31122862827",
          name: "ถาดสแตนเลส",
          image: "",
          requestAmount: 2,
          actualAmount: 2,
          installedAmount: 2,
          damagedAmount: 0,
          damagedReason: "",
          lostAmount: 0,
          lostReason: "",
          remark: "",
          price: 0,
          actualPrice: 0,
          delFlag: false,
        },
      ],
      imgUrls: [],
    },
    signatureImgId: "",
  },
  error: null,
  xTotalCount: 0,
};

export class APIEvent {
  // COMMON
  async getActionStatus() {
    if (isMockup) {
      await delay(300);
      return {
        result: true,
        responseCode: "200",
        responseMessage: "Success",
        responseDataSource: "mock",
        data: mockActionStatusList,
        error: null,
      };
    }

    const config = {
      method: "get",
      url: `/api/Event/GetEventActionStatus`,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async getEventList(params: any) {
    if (isMockup) {
      await delay(300);
      let filtered = [...mockEventList];

      if (params?.searchText) {
        const query = params.searchText.toLowerCase();
        filtered = filtered.filter(
          (item) =>
            item.eventName.toLowerCase().includes(query) ||
            (item.address && item.address.toLowerCase().includes(query)),
        );
      }

      if (params?.eventStatusGroup) {
        const groups = Array.isArray(params.eventStatusGroup)
          ? params.eventStatusGroup.map(Number)
          : [Number(params.eventStatusGroup)];
        if (groups.length > 0) {
          filtered = filtered.filter((item) =>
            groups.includes(item.eventStatusGroup),
          );
        }
      }

      const total = filtered.length;

      return {
        result: true,
        responseCode: "200",
        responseMessage: "Success",
        data: filtered,
        xTotalCount: total,
        error: null,
      };
    }

    const config = {
      method: "get",
      url: `/api/Event/List`,
      params,
    };
    try {
      const res = await axios(config);
      const data = res.data;
      if (res.headers["x-total-count"]) {
        data.xTotalCount = parseInt(res.headers["x-total-count"], 10);
      }
      return data;
    } catch (err) {
      throw err;
    }
  }

  async getTechnician(
    eventId: number,
    searchText: string,
    offset: number,
    limit: number,
  ) {
    if (isMockup) {
      await delay(300);
      let filtered = mockTechnicianList;
      if (searchText) {
        filtered = filtered.filter(
          (t) =>
            t.firstname.includes(searchText) ||
            t.lastname.includes(searchText) ||
            t.employeeId.includes(searchText),
        );
      }
      const total = filtered.length;
      const paginated = filtered.slice(offset, offset + limit);
      return {
        result: true,
        responseCode: "200",
        responseMessage: "Success",
        data: paginated,
        xTotalCount: total,
        error: null,
      };
    }

    const config = {
      method: "get",
      url: `/api/Event/SearchTechnician`,
      params: { eventId, searchText, offset, limit },
    };
    try {
      const res = await axios(config);
      const data = res.data;
      if (res.headers["x-total-count"]) {
        data.xTotalCount = parseInt(res.headers["x-total-count"], 10);
      }
      return data;
    } catch (err) {
      throw err;
    }
  }

  async getEventMasterMaterialGroup(matType?: string) {
    if (isMockup) {
      await delay(300);
      return {
        result: true,
        responseCode: "200",
        responseMessage: "Success",
        responseDataSource: "mock",
        data: {
          materialGroupList: mockMasterMaterialGroupList,
        },
        materialGroupList: mockMasterMaterialGroupList,
        error: null,
      };
    }

    const config = {
      method: "get",
      url: `/api/Event/MasterMaterialGroup`,
      params: { matType },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async getEventMasterMaterial(
    matType?: string,
    searchText?: string,
    matGroupId?: number,
    matBrandId?: number,
    page: number = 1,
    limit: number = 20,
  ) {
    if (isMockup) {
      await delay(300);
      let list = mockMasterMaterialList;
      if (matType) {
        list = list.filter(
          (item) =>
            !item.matType ||
            item.matType.toLowerCase() === matType.toLowerCase(),
        );
      }
      if (searchText) {
        list = list.filter(
          (item) =>
            item.name?.includes(searchText) || item.code?.includes(searchText),
        );
      }
      return {
        result: true,
        responseCode: "200",
        responseMessage: "Success",
        responseDataSource: "mock",
        data: list,
        total: list.length,
        error: null,
      };
    }

    const config = {
      method: "get",
      url: `/api/Event/MasterMaterial`,
      params: { matType, searchText, matGroupId, matBrandId, page, limit },
    };
    try {
      const res = await axios(config);
      const data = res.data;
      if (res.headers["x-total-count"]) {
        data.xTotalCount = parseInt(res.headers["x-total-count"], 10);
      }
      return data;
    } catch (err) {
      throw err;
    }
  }


  async approveEvent(data: { events: any[]; isApproved: boolean }) {
    if (isMockup) {
      await delay(300);
      return {
        result: true,
        responseCode: "200",
        responseMessage: "Success",
        responseDataSource: "mock",
        data: {
          result: true,
          message: "SUCCESS",
        },
        error: null,
      };
    }

    const config = {
      method: "post",
      url: `/api/Event/ApproveEvent`,
      data,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  // PRE-EVENT
  async getPreEventDetail(eventId: number) {
    if (isMockup) {
      await delay(300);
      const detailData = mockEventDetailsMap[eventId] || mockEventDetailsMap[2];
      return {
        result: true,
        responseCode: "200",
        responseMessage: "Success",
        responseDataSource: "mock",
        data: detailData,
        error: null,
      };
    }

    const config = {
      method: "get",
      url: `/api/Event/GetPreEventDetail/${eventId}`,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async updatePreEventDetail(data: any) {
    if (isMockup) {
      await delay(300);
      return {
        result: true,
        responseCode: "200",
        responseMessage: "Success",
        responseDataSource: "mock",
        isCalled: false,
        data: {
          eventId: data.eventId?.toString() || "2",
          result: true,
          message: "SUCCESS",
        },
        error: null,
        xTotalCount: 0,
      };
    }

    const config = {
      method: "put",
      url: `/api/Event/PreEventDetail`,
      data,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async updatePreEventDelivery(eventId: number, data: any) {
    if (isMockup) {
      await delay(300);
      return {
        result: true,
        responseCode: "200",
        responseMessage: "Success",
        responseDataSource: "mock",
        isCalled: false,
        data: {
          eventId: eventId?.toString() || "",
          result: true,
          message: "SUCCESS",
        },
        error: null,
        xTotalCount: 0,
      };
    }

    const config = {
      method: "put",
      url: `/api/Event/EventDelivery/${eventId}`,
      data,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async addPreEventTechnician(
    eventId: number,
    data: {
      isApproved: boolean;
      technician: { contactId: number[] };
      actualAmountTechnician?: number;
      detail?: string;
    },
  ) {
    if (isMockup) {
      await delay(300);
      return {
        result: true,
        responseCode: "200",
        responseMessage: "Success",
        responseDataSource: "mock",
        data: {
          result: true,
          message: "SUCCESS",
        },
        error: null,
      };
    }

    const config = {
      method: "post",
      url: `/api/Event/AddTechnician/${eventId}`,
      data,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async customerPreEventAccept(
    eventId: number,
    data: { isAccepted: boolean; reason?: string },
  ) {
    if (isMockup) {
      await delay(300);
      return {
        result: true,
        responseCode: "200",
        responseMessage: "Success",
        responseDataSource: "mock",
        data: {
          result: true,
          message: "SUCCESS",
        },
        error: null,
      };
    }

    const config = {
      method: "put",
      url: `/api/Event/${eventId}/CustomerAccept`,
      data,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async uploadPreEventReceipt(
    eventId: number,
    data: {
      imgUrls: string[];
      paymentType?: string;
      depositAmount?: number;
      note?: string;
      product?: any[];
    },
  ) {
    if (isMockup) {
      await delay(300);
      return {
        result: true,
        responseCode: "200",
        responseMessage: "Success",
        responseDataSource: "mock",
        data: {
          result: true,
          message: "SUCCESS",
        },
        error: null,
      };
    }

    const config = {
      method: "post",
      url: `/api/Event/${eventId}/UploadReceipt`,
      data,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  // ON-EVENT
  async getOnEvent(eventId: number) {
    if (isMockup) {
      await delay(300);
      return mockQuestEvent;
    }

    const config = {
      method: "get",
      url: `/api/Quests/Event/${eventId}`,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async getOnEventPayment(eventId: number) {
    if (isMockup) {
      await delay(300);
      return mockQuestEventDetail;
    }

    const config = {
      method: "get",
      url: `/api/Quests/Event/Payment/${eventId}`,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async updateOnEventPayment(
    eventId: number,
    data: UpdateOnEventDetailModel,
  ) {
    const config = {
      method: "put",
      url: `/api/Quests/Event/Payment/${eventId}`,
      data,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async getOnEventInstallation(eventId: number) {
    if (isMockup) {
      await delay(300);
      return mockOnEventInstallationDetail;
    }

    const config = {
      method: "get",
      url: `/api/Quests/Event/Installation/${eventId}`,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  async updateOnEventInstallation(
    eventId: number,
    data: UpdateOnEventInstallationModel,
  ) {
    const config = {
      method: "put",
      url: `/api/Quests/Event/Installation/${eventId}`,
      data,
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (err) {
      throw err;
    }
  }

  // POST-EVENT
}

export default APIEvent;
